<script lang="ts">
	import { getUserPortfolioValues } from '$lib/data/portfolio';
	import type { UserPortfolioChartRangeOptions } from '$lib/types/user';
	import {
		loadingUserPortfolioPoints,
		userPortfolioChartRange,
		userPortfolioPoints
	} from '$lib/portfolio/store.js';
	export let range: UserPortfolioChartRangeOptions;

	function setUserPortfolioChartRange(range: UserPortfolioChartRangeOptions) {
		if ($userPortfolioPoints && !$loadingUserPortfolioPoints) {
			$userPortfolioChartRange = range;
			getUserPortfolioValues();
		}
	}
</script>

<button
	class="px-2 py-1 cursor-pointer hover:bg-fx-grey-700 rounded"
	class:activeChartButton={$userPortfolioChartRange == range}
	on:click={() => setUserPortfolioChartRange(range)}
>
	{range}
</button>

<style>
	.activeChartButton {
		@apply text-fx-grey-200 bg-fx-grey-600;
	}
</style>
